/**
 * Design tokens — ported verbatim from shared.css `:root`.
 * These are the single source of truth for colour/space/radius in the portal.
 */
export const tokens = {
  color: {
    // Kindred brand
    kBlack: '#0A0A0A',
    kInk: '#1A1A1A',
    kPaper: '#FAFAF7',
    kLine: '#E8E6DF',
    kMuted: '#6B6B66',
    kAccent: '#2D2D2A',

    // Functional
    bg: '#FAFAF7',
    card: '#FFFFFF',
    text: '#141413',
    textMuted: '#6B6B66',
    link: "#2563EB",
    border: '#E8E6DF',

    // Status (from merchant.html .status / .kpi .delta / .o-step)
    successBg: '#DCFCE7',
    successText: '#15803D',
    successAccent: '#16A34A',
    warnBg: '#FEF3C7',
    warnText: '#92400E',
    neutralBg: '#F3F4F6',
    neutralText: '#6B7280',
    toggleOn: '#4ADE80',
    toggleOff: '#E5E7EB',
    deltaUp: '#16A34A',
    codeChipBg: '#F3F4F6',
  },
  shadow: {
    sm: '0 1px 2px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04)',
    lg: '0 4px 12px rgba(0,0,0,0.06), 0 16px 40px rgba(0,0,0,0.08)',
  },
  radius: {
    sm: '8px',
    base: '12px',
    lg: '20px',
    pill: '999px',
  },
  font: {
    sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    serif: "'Fraunces', 'Times New Roman', serif",
    mono: "'JetBrains Mono', ui-monospace, Menlo, monospace",
  },
  space: (n: number) => `${n * 4}px`,
} as const;

export type Tokens = typeof tokens;
